//import MultyModifyTextBookArea from "@/pages/comp/book_order/textbook/common/multy_modify";
import { useState, useRef, useEffect } from 'react';
import ListComponent from '@/pcomponents/common/crud/list/list/list_component';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import strFunc from '@/lib/lyg/string';
import { useSelector, useDispatch } from 'react-redux';
import getXcolumnJson from "./xcolumn/list";
import ManageArea from "./area/manage";

function MultyModifyTextBookArea(props: any) {
  let myProps = {
    book_seq_arr: [],
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    ...props
  };
  let user = useSelector((state: any) => state.user);
  const xColumnArr = getXcolumnJson();
  const ListComponentRef = useRef<any>(null);
  const listOptRef = useRef<any>({});
  const [listOpt, setListOpt] = useState({
    ...xColumnArr.list_opt,
    s_pri_arr: myProps.book_seq_arr,
    s_title_like: "",
    s_category_seq: "",
    s_sort1_seq: "",
    s_sort2_seq: "",
    s_sort3_seq: "",
    s_addon_textbook_sort: "1",
    s_addon_section: "1",
    s_addon_study: "1",
    s_addon_product: "1",
    "is_need_count": "",
    "is_need_info_arr": "1",
    "is_no_limit": "1",
  });
  listOptRef.current = listOpt;
  const [infoArr, setInfoArr] = useState([]);

  useEffect(() => {
    if (myProps.book_seq_arr.length == 0) {
      setInfoArr([]);
    } else {
      list({
        s_pri_arr: myProps.book_seq_arr
      });
    }
  }, [myProps.book_seq_arr]);

  const list = (inOptObj: any) => {
    let tmp_list_opt = {
      ...listOpt,
      ...inOptObj
    };
    setListOpt(tmp_list_opt);

    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/textbook/textbook/list',
      tmp_list_opt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          setInfoArr(response.data["data"]["info_arr"]);
          if (ListComponentRef.current) {
            ListComponentRef.current.setInfoArr(response.data["data"]["info_arr"]);
          }
        } else {

        }
      });
  };

  const go_select_write_by_ajax = (inData:any) => {
    let default_arr=[];
    if(ListComponentRef.current){
      default_arr=ListComponentRef.current.getSelectedRows();
    }
    let opt_obj={
      select_info_arr:default_arr,
      ...inData
    };

    let select_info_arr=opt_obj.select_info_arr;
    if(select_info_arr.length==0){
      alert("선택된 도서가 없습니다.");
      return false;
    }

    if(confirm("선택 수정하시겠습니까?")===false){
      return false;
    }

    let formJsonData = {
      "data_arr": select_info_arr,
      "is_update": "",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/textbook/textbook/write', formJsonData, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert(response.data["msg"]);
          list({});
          myProps.refreshData({});
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const rowOnClick = (rowData: any, idx: number, e: any, key: string) => {

  };

  const customCellRenderer = (params: any) => {
    /*
    {
      "rowData":rowData,
      "idx":idx,
      "key":key,
      "value":row_val,
      "origin_val":origin_val,
    }
    */
    if (params.key === "row_view_sort1") {
      if (params.rowData.bsort1_title) {
        params.value = params.rowData.bsort1_title;
      }
    } else if (params.key === "row_view_sort2") {
      if (params.rowData.bsort2_title) {
        params.value = params.rowData.bsort2_title;
      }
    } else if (params.key === "row_view_sort3") {
      if (params.rowData.bsort3_title) {
        params.value = params.rowData.bsort3_title;
      }
    } else if (params.key === "row_view_category") {
      if (params.rowData.bcategory_title) {
        params.value = params.rowData.bcategory_title;
      }
    } else if (params.key === "row_view_stock_cnt") {
      if (params.rowData.product_info) {
        params.value = strFunc.comma(params.rowData.product_info.a_stock_cnt);
      }
    }

    return params.value;
  };

  return (
    <div>
      <ManageArea
        infoArr={infoArr}
        setInfoArr={(inData:any)=>{
          setInfoArr(inData);
          if (ListComponentRef.current) {
            ListComponentRef.current.setInfoArr(inData);
          }
        }}
        ListComponentRef={ListComponentRef}
        go_select_write_by_ajax={go_select_write_by_ajax}
      ></ManageArea>
      <ListComponent
        ref={ListComponentRef}
        xColumnArr={{ ...xColumnArr }}
        gridOpt={{
          fix_left_num: xColumnArr.list_opt_arr.fix_left_num,
          is_add_idx_num: false,
          is_add_checkbox: true,
          td_align: "center",
          height: "auto",
          is_fix_width: true,
          rowMultiSelectWithClick: false,
          onGridReady: () => {

          },

          is_all_select_row_key: true,
          rowOnClick: rowOnClick,
          customCellRenderer: customCellRenderer,
          class_name_json: {
            table_div: "basic_list_div",
            td_div: "row-col-div",
            input_check: "chk_row",
            row_input: "row-input",
            data_row_tr: "data_row_tr",
            active_row: "active",
            empty_con_div: "list_empty_content_div",
          },
        }}
      ></ListComponent>
    </div>
  );
};
export default MultyModifyTextBookArea;